import { cva } from "class-variance-authority";
import { useHotkey } from "../../hooks";
import { Icon, type IconName } from "../../icons";

/** Props Interface */
interface LightboxControllerButtonProps {
	direction: "previous" | "next";
	onClick: () => void;
}

export function LightboxControllerButton({ direction, onClick }: LightboxControllerButtonProps) {
	/** Classes */
	const buttonClass = lightboxControllerButton({ direction });
	const iconName: IconName = direction === "previous" ? "ChevronLeft" : "ChevronRight";

	/** Hotkey */
	useHotkey(direction === "previous" ? "ArrowLeft" : "ArrowRight", onClick);

	/** Render */
	return (
		<div
			className={buttonClass}
			onClick={(e) => {
				e.stopPropagation();
				onClick();
			}}
		>
			<Icon
				name={iconName}
				color="white"
				size={18}
			/>
		</div>
	);
}

const lightboxControllerButton = cva(
	[
		"absolute top-1/2 -translate-y-1/2 flex flex-col gap-4 h-[60px] flex-center",
		"bg-black/80 px-2",
		"active:opacity-60",
	],
	{
		variants: {
			direction: {
				previous: "left-2.5 rounded-md",
				next: "right-2.5 rounded-md",
			},
		},
	},
);
